export default __webpack_public_path__ + "media/zurb/img/events/wired/second-harvest/second-harvest-photos-af32672b1abf2223a3267888100d0598.png";